import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Forbidden: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousPath = (location.state as { from?: string } | undefined)?.from;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      color: '#ffffff',
      padding: '24px',
      textAlign: 'center'
    }}>
      <div style={{
        fontSize: '96px',
        fontWeight: '700',
        lineHeight: '1',
        marginBottom: '16px'
      }}>
        403
      </div>
      <h1 style={{
        fontSize: '32px',
        fontWeight: '500',
        marginBottom: '12px'
      }}>
        Access Denied
      </h1>
      <p style={{
        maxWidth: '420px',
        color: 'rgba(255, 255, 255, 0.75)',
        marginBottom: '28px',
        lineHeight: 1.6
      }}>
        You don&apos;t have the necessary permissions to access this area. If you think this is a mistake, please contact your administrator.
      </p>
      <div style={{ display: 'flex', gap: '12px' }}>
        <button
          style={{
            background: 'linear-gradient(135deg, #4FACFE 0%, #00B4DB 100%)',
            border: 'none',
            borderRadius: '12px',
            padding: '12px 24px',
            color: '#ffffff',
            fontSize: '16px',
            fontWeight: 600,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onClick={() => navigate('/')}
        >
          <span className="material-icons" style={{ fontSize: '20px' }}>home</span>
          Back to Dashboard
        </button>
        {previousPath && (
          <button
            style={{
              background: 'rgba(255, 255, 255, 0.12)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              borderRadius: '12px',
              padding: '12px 24px',
              color: '#ffffff',
              fontSize: '16px',
              fontWeight: 500,
              cursor: 'pointer'
            }}
            onClick={() => navigate(previousPath)}
          >
            Go Back
          </button>
        )}
      </div>
    </div>
  );
};

export default Forbidden;
